import { render, staticRenderFns } from "./KpiDepartmentTable.vue?vue&type=template&id=75ec98ca&scoped=true&"
import script from "./KpiDepartmentTable.vue?vue&type=script&lang=js&"
export * from "./KpiDepartmentTable.vue?vue&type=script&lang=js&"
import style0 from "./KpiDepartmentTable.vue?vue&type=style&index=0&id=75ec98ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec98ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VIcon,VSimpleTable,VTextField})
